import { useEffect } from "react";
import { questionModel, ratingListModel } from "../../models";
import { getParentQuestions } from "../../services/api";
import { useDashboardContext } from "../customhook/dashboardHook";
import { useTokenContext } from "../customhook/tokenHook";
import { appConstants } from "../../utils/constants";

export const QuestionsProvider = ({ children }) => {
  const { dashboardStates, setDashboardStates } = useDashboardContext();
  const { validToken } = useTokenContext();

  useEffect(() => {
    if (validToken) {
      if (dashboardStates.sourceRating !== null) {
        const defaultRating = dashboardStates.sourceRating;
        const ratingData = ratingListModel(parseInt(defaultRating, 10));
        setDashboardStates((previousState) => {
          return {
            ...previousState,
            rating: defaultRating,
            sourceRating: null,
            ratingdata: ratingData,
          };
        });
      }
    }
  }, [
    dashboardStates.ratingdata,
    dashboardStates.sourceRating,
    validToken,
    setDashboardStates,
  ]);

  useEffect(() => {
    //Passing Selected Rating
    if (dashboardStates.rating !== null) {
      let parentQuestionResponse = async () => {
        setDashboardStates((previousState) => {
          return {
            ...previousState,
            parentQuestionloading: true,
          };
        });

        await getParentQuestions({
          selectedRating: dashboardStates.rating,
          surveyType: localStorage.getItem(appConstants.surveyType),
          language: localStorage.getItem(appConstants.language),
          conceptCode: localStorage.getItem(appConstants.conceptCode),
        }).then((response) => {
          if (response?.status === 200 || response?.status === 201) {
            const responseData = response.data.data.questions.map((questions) =>
              questionModel(questions.questionId, questions.questionName, false)
            );
            if (responseData != null && responseData.length > 0) {
              setDashboardStates((previousState) => {
                return {
                  ...previousState,
                  parentQuestiondata: responseData,
                  parentQuestionloading: false,
                };
              });
            }
            return responseData;
          } else if (response?.status === 401) {
            setDashboardStates((previousState) => {
              return {
                ...previousState,
                parentQuestionloading: false,
              };
            });
          } else {
            return null;
          }
        });
      };
      parentQuestionResponse();
    }
  }, [dashboardStates.rating, setDashboardStates]);

  return children;
};
